import React from 'react';


class Header extends React.Component {

    static propTypes = {
        classNameWrap: React.PropTypes.string,
        className: React.PropTypes.string,
        headerTitle: React.PropTypes.string,
    };

    static defaultProps = {
        classNameWrap: 'header-wrap',
        className: 'header',
        headerTitle: 'Header Title'
    };

    render() {
        const {
            classNameWrap,
            className,
            headerTitle,
        } = this.props;

        return (
            <div ref="headerRef" className={classNameWrap}>
                <header className={className}>

                    <div className="header__title">{headerTitle}</div>

                    {this.props.children}
                </header>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./app/components/controls/header/Header.jsx